import { ArrowRight, Building2 } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
export const EnterpriseCallout = () => {
  const {
    t
  } = useTranslation("pricing");
  const navigate = useNavigate();
  return <div className="mt-16">
      
    </div>;
};
const FeatureCard = ({
  title,
  description
}: {
  title: string;
  description: string;
}) => <div className="p-4 rounded-lg border bg-white">
    <h3 className="font-semibold mb-2">{title}</h3>
    <p className="text-sm text-gray-600">{description}</p>
  </div>;